import { api, apiAuth } from "../../../services/ApiService";
import { createRequest } from "../../../helpers/RequestHelper";

export function buscarFormulariosAtivos(onSuccess, onError) {
  return createRequest({
    api: api,
    method: "GET",
    path: "/forms/active",
    onSuccess,
    onError
  });
}

export function buscarTodosFormulariosAtivos(onSuccess, onError) {
  return createRequest({
    api: api,
    method: "GET",
    path: "/forms/all",
    onSuccess,
    onError
  });
}

export function enviarSubmissao(idForm, data, onSuccess, onError) {
  return createRequest({
    api: api,
    method: "POST",
    path: "/submits/" + idForm,
    data: data,
    onSuccess,
    onError
  });
}

export function enviarReSubmissao(
  idSubmissao,
  idForm,
  data,
  onSuccess,
  onError
) {
  return createRequest({
    api: api,
    method: "PUT",
    path: "/submits/" + idSubmissao + "/forms/" + idForm,
    data: data,
    onSuccess,
    onError
  });
}

export function buscarSubmissoesPorCPF(cpf, onSuccess, onError) {
  return createRequest({
    api: api,
    method: "GET",
    path: "/submits?access=" + cpf,
    onSuccess,
    onError
  });
}

export function buscarSubmissaoPorID(id, onSuccess, onError) {
  return createRequest({
    api: apiAuth,
    method: "GET",
    path: "/submits/" + id,
    onSuccess,
    onError
  });
}

export function uploadArquivo(data, idForm, cpf, onSuccess, onError) {
  return createRequest({
    api: api,
    method: "POST",
    path: "/submits/files/upload/" + idForm + "?access=" + cpf,
    data: data,
    onSuccess,
    onError
  });
}

// 192.168.24.119:9000/api/submits/academico?cpf={cpf}&tipo={Tipo}
export function buscarDadosInscricaoPorCPFETipo(cpf, tipo, onSuccess, onError) {
  const path = `/submits/academico?cpf=${cpf}&tipo=${tipo}`;
  return createRequest({
    api: api,
    method: "GET",
    path: path,
    onSuccess,
    onError
  });
}

export function sistemasDisponiveis(onSuccess, onError) {
  return createRequest({
    api: apiAuth,
    method: "GET",
    path: "/sistemas",
    onSuccess,
    onError
  });
}



// WEBPACK FOOTER //
// ./src/view/inicio/acoes/ApiActions.js